"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const Dropdown = createSvgIcon(
  <path
    id="expand_more_2"
    d="M11.9991 15.2478L6.69141 9.94012L7.39911 9.23242L11.9991 13.8324L16.5991 9.23242L17.3068 9.94012L11.9991 15.2478Z"
  />,
  "Dropdown",
)

const DropdownIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <Dropdown sx={{ fill: _fill, ...sx }} {...rest} />
}

export default DropdownIcon
